<template>
  <el-dropdown v-bind="$attrs" @command="params=>$emit('command',params)">
    <slot name="head"></slot>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="(v,i) in item.data" :key="i" :icon="v.icon" :style="{color:v.color}">
        <slot name="dropdown" :row="v" :index="i"></slot>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>

export default {
  components: {},
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {},
  beforeDestroy() {
  },
  destroyed() {
  },
}

</script>

<style scoped lang="scss">

</style>

